import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";

// //////////////////
// Action Creators //
// //////////////////

export const CargarSolicitudes = (solicitudes) => ({
  type: "CARGAR_SOLICITUDES",
  solicitudes,
});

export const Loading = (loading) => ({
  type: "FILTROBUSQUEDASR/LOADING",
  loading,
});

export const CambiarTipoSolicitud = (tipoSolicitud) => ({
  type: "FILTROBUSQUEDASR/CAMBIAR_TIPO_SOLICITUD",
  tipoSolicitud,
});

export const CambiarEstadoSolicitud = (estadoSolicitud) => ({
  type: "FILTROBUSQUEDASR/CAMBIAR_ESTADO_SOLICITUD",
  estadoSolicitud,
});

export const CambiarIdSolicitud = (valor, error) => ({
  type: "FILTROBUSQUEDASR/CAMBIAR_IDSOLICITUD",
  valor,
  error,
});

export const CambiarFechaSolicitudDesde = (valor, error) => ({
  type: "FILTROBUSQUEDASR/CAMBIAR_FECHA_SOLICITUD_DESDE",
  valor,
  error,
});

export const CambiarFechaSolicitudHasta = (valor, error) => ({
  type: "FILTROBUSQUEDASR/CAMBIAR_FECHA_SOLICITUD_HASTA",
  valor,
  error,
});


// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const BuscarSolicitudes = () => (dispatch) => {
  const filtrosBusqueda = store.getState().filtroBusquedaSR.filtros;

  const globalState = store.getState().global;
  const estSol = filtrosBusqueda.estadoSolicitud;
  const tipSol = filtrosBusqueda.tipoSolicitud;
  const fecSol = filtrosBusqueda.fechaSolicitud;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    token: globalState.token,
    IdSolicitud: filtrosBusqueda.idSolicitud === "" ? null : filtrosBusqueda.idSolicitud,
    FechaSolicitudDesde: typeof filtrosBusqueda.fechaSolicitudDesde === "undefined" ? null : filtrosBusqueda.fechaSolicitudDesde,
    FechaSolicitudHasta: typeof filtrosBusqueda.fechaSolicitudHasta === "undefined" ? null : filtrosBusqueda.fechaSolicitudHasta,
  };
  if (estSol && estSol !== 0 && estSol !== "0") { params.EstadoSolicitud = estSol; }
  if (tipSol && tipSol !== 0 && tipSol !== "0") { params.TipoSolicitud = tipSol; }
  if (fecSol && fecSol !== 0 && fecSol !== "0" && fecSol !== null) { params.FechaSolicitud = fecSol; }

  fetch(`${apiConfig.apiUri}/v1/solicitudes/search`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.json();
    })
    .then((json) => {
      if (Array.isArray(json)) {
        //trace.information("BuscarSolicitudes", json);
        dispatch(CargarSolicitudes(json));
      } else {
        throw json;
      }
    })
    .catch((error) => {
      trace.error("BuscarSolicitudes", error);
      dispatch(ErrorSnacktOpen(
        "Error al buscar las solicitudes:",
        error,
      ));
    });
};



// WEBPACK FOOTER //
// ./src/components/SolicitudesRealizadas/FiltroBusqueda/actions.js